import { render, staticRenderFns } from "./toFront.vue?vue&type=template&id=5890fe6a&"
import script from "./toFront.vue?vue&type=script&lang=ts&"
export * from "./toFront.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports